import { useEffect } from "react";
import { toaster } from "@/components/ui/toaster";
import { useTranslation } from "react-i18next";

const TOAST_ID = "slowRequestToast";
const DEFAULT_TIMEOUT_MS = 5000;

export const useSlowRequestToast = ({
    isLoading,
    timeoutMs = DEFAULT_TIMEOUT_MS,
    message
}: {
    isLoading: boolean;
    timeoutMs?: number;
    message?: string;
}) => {
    const { t } = useTranslation(["common"]);

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout> | undefined;

        if (isLoading) {
            timer = setTimeout(() => {
                if (!toaster.isVisible(TOAST_ID)) {
                    toaster.create({
                        id: TOAST_ID,
                        title: message ?? t("common:slowRequestToast"),
                        type: "info",
                        closable: true
                    });
                }
            }, timeoutMs);
        }

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
            toaster.dismiss(TOAST_ID);
        };
    }, [isLoading, timeoutMs, message, t]);
};
